<template>
  <b-modal id="modal-edit-barang" ref="modalEditBarang" title="Edit Barang" variant="success" size="lg" hide-footer
    no-close-on-esc no-close-on-backdrop>
    <loading :active.sync="this.$store.state.barpin.isLoading" :is-full-page="false"></loading>
    <form @submit.prevent="saveBarang">
      <b-form-fieldset label="Uraian Barang">
        <b-form-input type="text" name="Uraian Barang" :class="errors.has('Uraian Barang') ? 'is-invalid' : ''"
          placeholder="..." v-validate="'required'" :value="model('URAIAN_BARANG')"
          @input="updateBarang('URAIAN_BARANG', $event)"></b-form-input>
        <div v-show="errors.has('Uraian Barang')" class="invalid-feedback">{{ errors.first('Uraian Barang') }}</div>
      </b-form-fieldset>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jumlah Satuan">
            <b-form-input type="number" name="Jumlah Satuan" placeholder="..."
              :class="errors.has('Jumlah Satuan') ? 'is-invalid' : ''" :value="model('JML_SATUAN')"
              @input="updateBarang('JML_SATUAN', $event)" v-validate="'required'"></b-form-input>
            <div v-show="errors.has('Jumlah Satuan')" class="invalid-feedback">{{ errors.first('Jumlah Satuan') }}</div>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jenis Satuan">
            <model-list-select class="form-control" :list="satuan" option-value="JNS_SAT"
              :custom-text="(item) => `${item.JNS_SAT} - ${item.UR_SAT}`" :value="model('JNS_SATUAN')"
              @input="updateBarang('JNS_SATUAN', $event)" name="Jenis Satuan" v-validate="'required'"
              :class="errors.has('Jenis Satuan') ? 'is-invalid' : ''" placeholder="Jenis Satuan"></model-list-select>
            <div v-show="errors.has('Jenis Satuan')" class="invalid-feedback">{{ errors.first('Jenis Satuan') }}</div>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jumlah Kemasan">
            <b-form-input type="number" placeholder="..." :value="model('JML_KEMASAN')"
              @input="updateBarang('JML_KEMASAN', $event)" name="Jumlah Kemasan" v-validate="'required'"
              :class="errors.has('Jumlah Kemasan') ? 'is-invalid' : ''"></b-form-input>
            <div v-show="errors.has('Jumlah Kemasan')" class="invalid-feedback">{{ errors.first('Jumlah Kemasan') }}
            </div>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jenis Kemasan">
            <model-list-select class="form-control" :list="kemasan" option-value="JNS_KMS"
              :custom-text="(item) => `${item.JNS_KMS} - ${item.UR_KMS}`" :value="model('JNS_KEMASAN')"
              @input="updateBarang('JNS_KEMASAN', $event)" v-validate="'required'" name="Jenis Kemasan"
              :class="errors.has('Jenis Kemasan') ? 'is-invalid' : ''" placeholder="Jenis Kemasan"></model-list-select>
            <div v-show="errors.has('Jenis Kemasan')" class="invalid-feedback">{{ errors.first('Jenis Kemasan') }}</div>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Bruto">
            <b-form-input type="number" placeholder="..." :value="model('BRUTO')"
              @input="updateBarang('BRUTO', $event)"></b-form-input>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Netto">
            <b-form-input type="number" placeholder="..." :value="model('NETTO')"
              @input="updateBarang('NETTO', $event)"></b-form-input>
          </b-form-fieldset>
        </div>
      </div>
      <b-form-fieldset label="Nilai Barang (Rp)">
        <vue-numeric class="form-control" currency="Rp" separator="." decimal="0" :value="model('CIF')"
          @input="updateBarang('CIF', $event)"></vue-numeric>
      </b-form-fieldset>
      <b-form-fieldset label="HS Code">
        <b-form-input maxlength="8" type="text" :value="model('HS_CODE')" @input="updateBarang('HS_CODE', $event)">
        </b-form-input>
        <small>digit only</small>
        <!-- <vue-numeric class="form-control" output-type="String" v-model="hs_code"></vue-numeric> -->
        <!-- <div v-show="errors.has('Nilai Barang')" class="invalid-feedback">{{ errors.first('Nilai Barang') }}</div> -->
      </b-form-fieldset>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Tarif Bea Masuk">
            <b-input-group right="%">
              <vue-numeric class="form-control" :minus="false" :precision="1" :value="model('TARIF_BM')"
                @input="updateBarang('TARIF_BM', $event)"></vue-numeric>
            </b-input-group>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nilai Bea Masuk">
            <vue-numeric disabled class="form-control" currency="Rp" separator="." :value="nilai_bm"></vue-numeric>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Tarif PPN">
            <b-input-group right="%">
              <vue-numeric class="form-control" :minus="false" :precision="1" :value="model('TARIF_PPN')"
                @input="updateBarang('TARIF_PPN', $event)"></vue-numeric>
            </b-input-group>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nilai PPN">
            <vue-numeric disabled class="form-control" currency="Rp" separator="." :value="nilai_ppn"></vue-numeric>
          </b-form-fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Tarif PPh">
            <b-input-group right="%">
              <vue-numeric class="form-control" :minus="false" :precision="1" :value="model('TARIF_PPH')"
                @input="updateBarang('TARIF_PPH', $event)"></vue-numeric>
            </b-input-group>
          </b-form-fieldset>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Nilai PPh">
            <vue-numeric disabled class="form-control" currency="Rp" separator="." :value="nilai_pph"></vue-numeric>
          </b-form-fieldset>
        </div>
      </div>
      <slot id="footer">
        <hr />
        <button type="submit" class="btn btn-success pull-right">
          <i class="fa fa-edit"></i> Simpan
        </button>
      </slot>
    </form>
  </b-modal>
</template>
<script>
import {mapActions} from 'vuex'
import swal from 'sweetalert'
export default {
  data () {
    return {
      satuan: [],
      kemasan: []
    }
  },
  computed: {
    nilai_bm () {
      return this.model('CIF') * (this.model('TARIF_BM') / 100)
    },
    nilai_ppn () {
      return (this.model('CIF') + this.nilai_bm) * (this.model('TARIF_PPN') / 100)
    },
    nilai_pph () {
      return (this.model('CIF') + this.nilai_bm) * (this.model('TARIF_PPH') / 100)
    }
  },
  created () {
    this.getSatuan()
    this.getKemasan()
  },
  methods: {
    ...mapActions({
      setBarang: 'barpin/updateBarang'
    }),
    model (name) {
      return this.$store.state.barpin.current_barang[name]
    },
    updateBarang (where, event) {
      // console.log(event)
      this.$store.commit('barpin/UPDATE_BARANG', {value: event, where: where})
    },
    saveBarang () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('barpin/SET_LOADING', true)
          var dataSet = {
            ...this.$store.state.barpin.current_barang,
            nilai_bm: this.nilai_bm,
            nilai_ppn: this.nilai_ppn,
            nilai_pph: this.nilai_pph
          }
          console.log(dataSet)
          this.setBarang(dataSet).then(() => {
            this.$refs['modalEditBarang'].hide()
            this.$store.commit('barpin/SET_LOADING', false)
          }).catch((error) => {
            swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
            this.$store.commit('barpin/SET_LOADING', false)
          })
        }
      })
    },
    getSatuan () {
      this.$http.get('ref/jnsatuan').then((response) => {
        this.satuan = response.data
      })
    },
    getKemasan () {
      this.$http.get('ref/jnskemasan').then((response) => {
        this.kemasan = response.data
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalEditBarang.vue?5c4d5a2c